document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".resource-list__dots").forEach(wrapper => {
    const ref = wrapper.dataset.ref;
    const slideshow = document.querySelector(`slideshow-component[ref="${ref}"]`);
    const dots = wrapper.querySelectorAll(".dot");

    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        const index = dot.dataset.index;
        slideshow.setAttribute("initial-slide", index);
      });
    });

    let current = 0;
    dots[current]?.classList.add("active");

    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        dots.forEach(d => d.classList.remove("active"));
        dots[i].classList.add("active");
      });
    });
  });

  //script for product more info dropdown

  // document.querySelectorAll('.product-more-information h3').forEach(function(header){
  //   header.addEventListener('click', function(){
  //     this.parentElement.classList.toggle('active');
  //   });
  // });

  // script for changing buy now button text

  function updateBuyNowText() {
    document.querySelectorAll('.shopify-payment-button__button--unbranded')
      .forEach(btn => {
        if (btn.innerText !== "Buy Now") {
          btn.innerText = "Buy Now";
        }
      });
  }

  updateBuyNowText();

  // Watch for Shopify re-render (variant change, etc.)
  const observer = new MutationObserver(() => {
    updateBuyNowText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  //script for custom thumbnail show more btn

  
  if (document.querySelectorAll('.show-more-thumbnails').length) {
    window.addEventListener('DOMContentLoaded', function() {
      var btn = document.querySelector('.show-more-thumbnails');
      if (btn) {
        btn.addEventListener('click', function() {
          document.querySelectorAll('.slideshow-controls__thumbnail.hidden').forEach(function(el) {
            el.classList.remove('hidden');
          });
          btn.style.display = "none";  // Optional: Hide the button after showing
        });
      }
    });
  }


  //script for article page link copied popup 
     document.querySelectorAll('a.copy-article-url').forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const url = this.href;
        const popup = document.querySelector('.link-copied-popup');

        function showPopup() {
          popup.style.display = 'flex';
          popup.style.opacity = '1';

          setTimeout(() => {
            popup.style.transition = 'opacity 1s';
            popup.style.opacity = '0';
          }, 2000); 

          setTimeout(() => {
            popup.style.display = 'none';
            popup.style.transition = '';
          }, 2700);
        }

        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            showPopup();
          }).catch(() => {
            alert('Failed to copy URL. Please copy manually.');
          });
        } else {
          const input = document.createElement('input');
          document.body.appendChild(input);
          input.value = url;
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          showPopup();
        }
      });
    });

  var canonicalLink = document.querySelector('link[rel="canonical"]');

  if (canonicalLink.href == "https://brewforyou.in/cart") {
    window.location.href = "https://brewforyou.in/";
  }
});



